export const GARAGE = {
  nom: "Promo Pneus",
  adresse: "40 chemin du Périer, 06110 Le Cannet",
  telephone: "04 93 46 39 67",
  telephoneLien: "+33493463967",
  email: "promopneus06@gmail.com",
  horairesTexte: "Du lundi au samedi, de 9h à 12h et de 14h à 18h",
  mapsItineraire:
    "https://www.google.com/maps/dir/?api=1&destination=40+chemin+du+P%C3%A9rier,+06110+Le+Cannet",
  mapsEmbed:
    "https://www.google.com/maps?q=40+chemin+du+P%C3%A9rier,+06110+Le+Cannet&output=embed",
};

export const IMAGES = {
  devanture: "/api/uploads/189f137263a6453ba342bd02b619bdf2.webp",
  comptoir: "/api/uploads/dfb788cbb1d946cd9132bc640feebafc.webp",
  fresque: "/api/uploads/2825967a64424922b099bb3387a03568.webp",
  hero: "/api/uploads/2825967a64424922b099bb3387a03568.webp",
  montage: "/api/uploads/montage.webp",
  equilibrage: "/api/uploads/equilibrage.webp",
  crevaison: "/api/uploads/crevaison.webp",
  parallelisme: "/api/uploads/parallelisme.webp",
  suspension: "/api/uploads/suspension.webp",
  trajectoire: "/api/uploads/trajectoire.webp",
  climStation: "/api/uploads/climatisation.webp",
  filtre: "/api/uploads/filtre.webp",
  vidange: "/api/uploads/vidange.webp",
  diagnostic: "/api/uploads/diagnostic.webp",
  freinage: "/api/uploads/freinage.webp",
  pneuMontage:
    "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxtZWNoYW5pYyUyMGNoYW5naW5nJTIwdHlyZXxlbnwwfHx8fDE3ODc4NDU3MjN8MA&ixlib=rb-4.1.0&q=85",
  clim:
    "https://images.pexels.com/photos/6130/cold-car-bmw-e46.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  moteur: "/api/uploads/moteur.webp",
  pneusStock: "/api/uploads/pneus_stock.webp",
};

export const NAV_LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/pneumatique", label: "Pneumatique" },
  { to: "/parallelisme", label: "Parallélisme" },
  { to: "/climatisation", label: "Climatisation" },
  { to: "/mecanique", label: "Mécanique" },
  { to: "/catalogue", label: "Catalogue" },
  { to: "/contact", label: "Contact" },
];

export const TARIFS_DEFAUT = {
  pneus: {
    titre: "TARIFS SERVICES PNEUMATIQUES",
    rows: [
      { prestation: "Montage de pneumatiques", prix: "à partir de 20 € / pneu" },
      { prestation: "Équilibrage de roues", prix: "à partir de 10 € / roue" },
      { prestation: "Réparation crevaison", prix: "à partir de 15 € / réparation" },
    ],
  },
  climatisation: {
    titre: "TARIFS CLIMATISATION",
    rows: [
      { prestation: "Recharge simple", prix: "à partir de 50 €" },
      { prestation: "Recharge premium", prix: "à partir de 80 €" },
    ],
  },
  mecanique: {
    titre: "TARIFS SERVICES MÉCANIQUES",
    rows: [
      { prestation: "Vidange et révision", prix: "à partir de 50 €" },
      { prestation: "Diagnostic auto", prix: "à partir de 40 €" },
      { prestation: "Remplacement freinage", prix: "à partir de 40 €" },
      { prestation: "Autres services de mécanique", prix: "Nous consulter" },
    ],
  },
  parallelisme: {
    titre: "TARIFS PARALLÉLISME",
    rows: [
      { prestation: "Réglage parallélisme train avant", prix: "[PRIX À COMPLÉTER]" },
      { prestation: "Réglage parallélisme 4 roues", prix: "[PRIX À COMPLÉTER]" },
      { prestation: "Contrôle géométrie", prix: "[PRIX À COMPLÉTER]" },
    ],
  },
};
